function Delete(props: any) {
    return (
        <div className={props.className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M6.08975 17.0861C5.67415 17.0861 5.31919 16.9389 5.02485 16.6446C4.73051 16.3502 4.58333 15.9953 4.58333 15.5797V5.00277H3.75V3.75279H7.49998V3.01562H12.5V3.75279H16.25V5.00277H15.4166V15.5797C15.4166 16.0006 15.2708 16.3569 14.9791 16.6486C14.6875 16.9403 14.3312 17.0861 13.9102 17.0861H6.08975ZM14.1666 5.00277H5.83331V15.5797C5.83331 15.6545 5.85735 15.7159 5.90544 15.764C5.95352 15.8121 6.01496 15.8361 6.08975 15.8361H13.9102C13.9743 15.8361 14.0331 15.8094 14.0865 15.756C14.1399 15.7025 14.1666 15.6438 14.1666 15.5797V5.00277ZM7.83654 14.1694H9.08652V6.66944H7.83654V14.1694ZM10.9134 14.1694H12.1634V6.66944H10.9134V14.1694Z" fill="currentColor" />
            </svg>
        </div>
    );
}

export default Delete;
